import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "link-attachment" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "link-attachment__icon-wrapper" }
const _hoisted_4 = { class: "link-attachment__content" }
const _hoisted_5 = { class: "link-attachment__text" }
const _hoisted_6 = { class: "link-attachment__url" }

import type { Attachment } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";

interface Props {
  attachment: Attachment;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkAttachment',
  props: {
    attachment: {}
  },
  setup(__props: any) {



const getDomainFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace("www.", "");
  } catch {
    return url;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.attachment.url)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: __props.attachment.url,
          target: "_blank",
          class: "link-attachment__card",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Icon), {
              icon: "mdi:link-variant",
              class: "link-attachment__icon"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.attachment.name || __props.attachment.url), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(getDomainFromUrl(__props.attachment.url)), 1)
          ]),
          _createVNode(_unref(Icon), {
            icon: "mdi:open-in-new",
            class: "link-attachment__external"
          })
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})